import { useState } from 'react';

export default function FAQSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => setOpenFaq(openFaq === index ? null : index);

  const faqs = [
    {
      question: 'Что входит в программу корпоративного тренинга по продажам?',
      answer: 'Программа включает диагностику текущих показателей отдела продаж, изучение бизнес-процессов компании, прослушивание реальных звонков, анализ переписок, интервью с сотрудниками, подготовку индивидуальной программы, практический тренинг на реальных кейсах компании (80% практики), домашние задания, разбор звонков и переписок, работу с руководителем отдела, посттренинговое сопровождение от 1 до 6 месяцев и создание книги продаж.',
    },
    {
      question: 'Сколько длится тренинг по продажам для сотрудников?',
      answer: 'Продолжительность зависит от выбранного формата и задач. Интенсив — 1–2 дня, модульное обучение — от 2 недель до 3 месяцев, комплексная программа с сопровождением — от 1 до 6 месяцев. Точная продолжительность определяется после диагностики и согласования целей.',
    },
    {
      question: 'Как измерить эффективность тренинга по продажам?',
      answer: 'Эффективность измеряется по конкретным KPI: рост конверсии на каждом этапе воронки, увеличение среднего чека, снижение процента скидок, рост повторных продаж, сокращение цикла сделки, рост количества квалифицированных лидов. Мы фиксируем исходные показатели до тренинга и отслеживаем динамику в течение 1–6 месяцев после.',
    },
    {
      question: 'Можно ли провести обучение менеджеров по продажам онлайн?',
      answer: 'Да, корпоративный тренинг по продажам проводится в онлайн-формате с использованием интерактивных инструментов, практических заданий, разбора реальных кейсов и ролевых игр. Онлайн-формат не уступает очному по эффективности при правильной организации.',
    },
    {
      question: 'Для каких компаний подходит корпоративное обучение продажам?',
      answer: 'Тренинг подходит для компаний из сфер B2B и B2C: производство, услуги, IT и разработка ПО, логистика и перевозки, строительство и девелопмент, медицина и фармацевтика, розничная и оптовая торговля, образование и EdTech, финансы и страхование, телекоммуникации. Программа адаптируется под специфику отрасли, продукта и цикла продаж.',
    },
    {
      question: 'Чем ваш тренинг по продажам отличается от других?',
      answer: 'Ключевые отличия: 1) предварительная диагностика и аудит перед тренингом; 2) отсутствие шаблонных программ — всё разрабатывается под компанию; 3) работа с реальными кейсами и звонками компании; 4) 80% практики, а не лекций; 5) сопровождение после тренинга от 1 до 6 месяцев; 6) создание книги продаж; 7) личный опыт тренера в продажах 18+ лет; 8) работа «в поле» вместе с сотрудниками.',
    },
    {
      question: 'Сколько стоит корпоративный тренинг по продажам?',
      answer: 'Стоимость зависит от формата, продолжительности, количества участников и специфики задач. Каждая программа разрабатывается индивидуально. Для получения точного расчёта оставьте заявку — мы проведём бесплатную экспресс-диагностику и подготовим предложение в течение 2 рабочих дней.',
    },
    {
      question: 'Даёте ли вы гарантию результата после обучения продажам?',
      answer: 'Мы гарантируем рост показателей при условии внедрения всех рекомендаций и прохождения полного цикла: диагностика → обучение → сопровождение. Наши кейсы подтверждают рост конверсии на 18–55% при комплексном подходе. Результат — это совместная работа тренера, сотрудников и руководителя.',
    },
    {
      question: 'Нужно ли участвовать руководителю отдела продаж в тренинге?',
      answer: 'Да, участие РОПа критически важно. Руководитель получает инструменты для контроля качества, наставничества и поддержки изменений после тренинга. Без вовлечения руководителя эффективность обучения снижается в 2–3 раза. Мы проводим отдельную работу с РОПом параллельно с обучением команды.',
    },
    {
      question: 'Что такое книга продаж и зачем она нужна?',
      answer: 'Книга продаж — это документ, который фиксирует стандарты, скрипты, чек-листы, регламенты и лучшие практики отдела продаж. Она позволяет масштабировать успешный опыт, быстро вводить в должность новых сотрудников и обеспечивать единый стандарт качества работы всей команды.',
    },
    {
      question: 'Как проходит посттренинговое сопровождение отдела продаж?',
      answer: 'Сопровождение включает регулярные встречи с руководителем отдела (раз в 1–2 недели), выборочный аудит звонков и переписок, корректировку скриптов, ответы на вопросы сотрудников в чате, контроль внедрения книги продаж, повторную диагностику показателей через 1, 3 и 6 месяцев.',
    },
    {
      question: 'Есть ли минимальное или максимальное количество участников?',
      answer: 'Оптимальное количество участников для корпоративного тренинга — от 6 до 16 человек. При меньшем количестве мы предлагаем индивидуальную программу. При большем — делим команду на группы для сохранения качества отработки навыков каждого участника.',
    },
  ];

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы о <strong>тренинге по продажам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ответы на самые популярные вопросы о <strong>корпоративном обучении продажам</strong>. Если вы не нашли ответа — напишите или позвоните.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-base md:text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  {openFaq === index ? (
                    <i className="ri-arrow-up-s-line text-teal-600"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-teal-600"></i>
                  )}
                </div>
              </button>
              <div className={`px-6 pb-6 ${openFaq === index ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}